import { RESET_STORE } from '../../store/constants/general';

export function resetStore() {
  return {
    type: RESET_STORE,
  };
}
